export default __webpack_public_path__ + "images/avatar.50c0e159.svg";